import React, { useState, useCallback } from "react";
import {
  Card, CardTitle, CardBody, Typography, Link, Skeleton, SkeletonLine, SkeletonContent,
} from "@one-thd/sui-atomic-components";

const ConfiguredCardTitle = ({ cardTitleConfig, titleOverride }) => {

  const { header, action, dynamicTitle, ...titleProps } = cardTitleConfig;

  let headerElement = null;
  if (header && dynamicTitle && !titleOverride) {
    headerElement = (
      <Skeleton>
        <SkeletonContent>
          <SkeletonLine width="200px" />
        </SkeletonContent>
      </Skeleton>
    );
  } else if (header) {
    const { variant, weight, className, text, ...restHeaderProps } = header;
    headerElement = (
      <Typography
        variant={variant || "h3"}
        weight={weight || "regular"}
        className={className}
        {...restHeaderProps}
      >
        {titleOverride || text}
      </Typography>
    );
  }

  let actionElement = null;
  if (action) {
    actionElement = (
      <Link href={action.href} className={action.className}>
        {action.text}
      </Link>
    );
  }

  return (
    <CardTitle
      header={headerElement}
      action={actionElement}
      {...titleProps}
    />
  );
};

export const withCard = (WrappedComponent, options) => {
  const CardWrapper = (props) => {
    const { card = {}, cardBody: cardBodyProps, cardTitle } = options || {};
    const [apiTitle, setApiTitle] = useState(null);
    const onTitleReady = useCallback((title) => {
      if (typeof title === "string" && title.trim()) setApiTitle(title);
    }, []);

    const cardProps = {
      className: "sui-h-full",
      ...card,
    };

    return (
      <Card {...cardProps}>
        {cardTitle && <ConfiguredCardTitle cardTitleConfig={cardTitle} titleOverride={apiTitle} />}
        <CardBody {...cardBodyProps}>
          <WrappedComponent {...props} onTitleReady={onTitleReady} />
        </CardBody>
      </Card>
    );
  };
  CardWrapper.dataModel = WrappedComponent.dataModel || {};
  CardWrapper.wraps = { ...(WrappedComponent.wraps || {}), card: true };
  CardWrapper.$$typeof = WrappedComponent.$$typeof;
  CardWrapper.displayName = WrappedComponent.displayName;

  return CardWrapper;
};